import { useState } from 'react';
import type { Filter } from '../../types/widget';

interface DateRangeFilterProps {
    label: string;
    defaultStart?: string;
    defaultEnd?: string;
    dateDimension?: string;
    onChange: (filters: Filter[]) => void;
}

export function DateRangeFilter({ label, defaultStart, defaultEnd, dateDimension, onChange }: DateRangeFilterProps) {
    const [start, setStart] = useState(defaultStart ?? '');
    const [end, setEnd] = useState(defaultEnd ?? '');

    const dimId = dateDimension ?? 'invoice_month';

    function handleChange(newStart: string, newEnd: string) {
        setStart(newStart);
        setEnd(newEnd);

        if (newStart && newEnd) {
            const startMonth = newStart.slice(0, 7);
            const endMonth = newEnd.slice(0, 7);
            onChange([
                {
                    dimension_id: dimId,
                    operator: 'between',
                    value: [startMonth, endMonth],
                },
            ]);
        } else {
            onChange([]);
        }
    }

    return (
        <div className="flex items-center gap-3">
            <label className="text-sm font-medium text-gray-700 whitespace-nowrap">{label}</label>
            <input
                type="date"
                value={start}
                onChange={(e) => handleChange(e.target.value, end)}
                className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
            />
            <span className="text-gray-400 text-sm">-</span>
            <input
                type="date"
                value={end}
                onChange={(e) => handleChange(start, e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
            />
        </div>
    );
}
